if (!customElements.get('museum-feature-grid')) {
  customElements.define('museum-feature-grid', class MuseumFeatureGrid extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.cardList = this.querySelector('[data-card-list]');
      this.updateState();

      this.resizeObserver = new ResizeObserver(() => this.updateState());
      if (this.cardList) this.resizeObserver.observe(this.cardList);

      this.onBlockSelect = (event) => {
        if (!this.contains(event.target) || !event.target.matches('[data-card]')) return;
        event.target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.dataset.initialized = 'false';
    }

    updateState() {
      if (!this.cardList) return;
      this.cardList.classList.toggle('is-scrollable', this.cardList.scrollWidth > this.cardList.clientWidth + 2);
    }
  });
}